import { render, staticRenderFns } from "./PassageExport.vue?vue&type=template&id=787b97e7&"
import script from "./PassageExport.vue?vue&type=script&lang=js&"
export * from "./PassageExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PassageExport.vue"
export default component.exports